import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { isInNativeTab } from '../../utils/nativeTab';
import { authService } from '../../Services/authService';

interface RequireAuthProps {
  children: React.ReactElement;
}

const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    if (isInNativeTab()) {
      // Attempt OIDC silent login via backend (with prompt=none for native tab)
      authService.signIn(location.pathname + location.search);
      return <LoadingSpinner />;
    }
    const searchParams = new URLSearchParams(location.search);
    const identityPath = searchParams.toString() ? `/identity?${searchParams.toString()}` : '/identity';

    return (
      <Navigate
        to={identityPath}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default RequireAuth;
